//react libraries
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { withRouter } from 'react-router-dom';

//assets
import logo from '../assets/img/logomark.png';
//import '../assets/css/style.css';

//components
import ProfileName from '../components/Profile/ProfileName';
import ProfileInterest from '../components/Profile/ProfileInterest';
import ProfileDoB from '../components/Profile/ProfileDoB';
import ProfileGender from '../components/Profile/ProfileGender';
import ProfileCampus from '../components/Profile/ProfileCampus';
import ProfilePicture from '../components/Profile/ProfilePicture';
import ProfileButton from '../components/Profile/elements/ProfileButton';
import ProfileVirtues from '../containers/ProfileVirtues';
import { CircularProgress } from '@material-ui/core';

//redux
import * as actions from '../store/actions/profileActions';
import { useDispatch, useSelector } from 'react-redux';

const univrsStepButton = (index, step) => {
    const icons = {
        0: <ProfileButton key={0} label="name" buttonStyleOn={step >= 0 ? true : false} />,
        1: <ProfileButton key={1} label="age" buttonStyleOn={step >= 1 ? true : false} />,
        2: <ProfileButton key={2} label="gender" buttonStyleOn={step >= 2 ? true : false} />,
        3: <ProfileButton key={3} label="campus" buttonStyleOn={step >= 3 ? true : false} />,
        4: <ProfileButton key={4} label="picture" buttonStyleOn={step >= 4 ? true : false} />,
        5: <ProfileButton key={5} label="interest" buttonStyleOn={step >= 5 ? true : false} />,
        6: <ProfileButton key={6} label="virtues" buttonStyleOn={step === 6 ? true : false} />
    };
    
    return icons[index];
}

const getSteps = () => {
    return ["name", "age", "gender", "campus", "picture", "interest", "virtues"];
}

const getStepHeading = () => {
    return [
        "What name would you like to go by?", 
        "Hey When were you born?", 
        "Great! Please select your gender identity", 
        "Which campus are you enrolled at?", 
        "Why don't you upload a picture of yourself?", 
        "Why don't you tell us what some of your interests are?"
    ];
}

const getStepContent = (step) => {
    switch (step) {
        case 0:
            return <ProfileName />;
        case 1:
            return <ProfileDoB />;
        case 2:
            return <ProfileGender />;
        case 3:
            return <ProfileCampus />;
        case 4:
            return <ProfilePicture />;
        case 5:
            return <ProfileInterest />;
        case 6:
            return <ProfileVirtues />;
        default:
            return 'Unknown step';
    }
}

const ProfileContainer = () => {
    const steps = getSteps();
    const stepsHeading = getStepHeading();
    const history = useHistory();

    const [activeStep, setActiveStep] = useState(0);
    const [isLoading, SetIsLoading] = useState(false);

    const profileState = useSelector(state => state.profile);
    const authState = useSelector(state => state.auth);
    const dispatch = useDispatch();

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        dispatch(actions.resetVirtue());
    }

    const handleReset = () => {
        setActiveStep(0);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        SetIsLoading(true);
        dispatch(actions.createProfile(profileState.profile))
            .then(() => {
                SetIsLoading(false);
                history.push('/');
            });
    };

    const renderNavButtons = () => {
        if (activeStep === 0) {
            return (
                <button onClick={handleNext} className="uni-btn">
                    Continue
                </button>
            );
        }
        else if(activeStep === steps.length - 1){
            return (
                <div style={{display:'flex'}}>
                    <button disabled={activeStep === 0} onClick={handleBack} style={{marginRight: '10px'}} className="uni-btn">
                        Back to Interests
                    </button>
                    {profileState.virtueStep === 6 ?
                        <button onClick={handleSubmit} className="uni-btn">
                            Finish
                        </button> : null
                    }
                </div>
            );
        }
        else if(activeStep === steps.length - 2){
            return (
                
                    <div style={{display:'flex'}}>
                        <button disabled={activeStep === 0} onClick={handleBack} style={{marginRight: '10px'}} className="uni-btn">
                            Back
                        </button>
                        <button onClick={handleNext} className="uni-btn">
                            Next
                        </button>
                    </div>
            );
        }
        else{
            return (
                <div style={{display:'flex'}}>
                    <button disabled={activeStep === 0} onClick={handleBack} style={{marginRight: '10px'}} className="uni-btn">
                        Back
                    </button>
                    <div>
                        {activeStep === steps.length - 1 ?
                            <button onClick={handleSubmit} className="uni-btn">
                                Finish
                            </button>
                            :
                            <button onClick={handleNext} className="uni-btn">
                                Next
                            </button>
                        }
                    </div>
                </div>
            );
        }
    }

    useEffect(() => {
        dispatch(actions.collectProfileData({...profileState.profile, userId: authState.user}));
    }, [authState.user]);

    return (
        <div className="root">
            <div className="container">
                <div className="row-1">
                    <img src={logo} alt="Universe" width="50px" height="auto"/>         
                </div>
                {activeStep === 6 ? 
                    null :
                    <div className="row-2">
                        <h3>{stepsHeading[activeStep]}</h3>
                    </div>
                }
                {activeStep === steps.length ? (
                    <div className="row-3">
                        <h4>
                            All steps completed - you&apos;re finished
                        </h4>
                        <button onClick={handleReset} className="uni-btn">
                            Reset
                        </button>
                    </div>
                    ) : (
                    <div className="row-3">
                        <div>{getStepContent(activeStep)}</div>
                        <div style={{display: 'block', margin: 'auto'}}>
                            {isLoading ? <CircularProgress /> : renderNavButtons()}
                        </div>
                    </div>
                )}
                <div className="row-4">
                    {steps.map((label, index) => (
                        univrsStepButton(index, activeStep)
                    ))}
                </div>
            </div>
        </div>
    );
};

export default withRouter(ProfileContainer);